// Lightweight i18n — translation dictionary + simple hook. Public pages only.
// Switch UI language via I18nContext.setLang / localStorage 'st_lang'.
import React from "react";

const DICT = {
    ro: {
        "nav.home": "Acasă",
        "nav.shop": "Magazin",
        "nav.packages": "Pachete",
        "nav.services": "Servicii",
        "nav.portfolio": "Portofoliu",
        "nav.blog": "Blog",
        "nav.contact": "Contact",
        "nav.login": "Autentificare",
        "nav.account": "Contul meu",
        "nav.cart": "Coș",
        "common.loading": "Se încarcă...",
        "common.save": "Salvează",
        "common.cancel": "Anulează",
        "common.delete": "Șterge",
        "common.search": "Caută...",
        "cta.add_to_cart": "Adaugă în coș",
        "cta.request_service": "Solicită acest serviciu",
        "product.out_of_stock": "Stoc epuizat",
        "product.notify_me": "Anunță-mă când revine în stoc",
        "product.specs": "Specificații",
        "product.description": "Descriere",
        "product.reviews": "Recenzii",
        "product.share": "Distribuie",
        "checkout.total": "Total",
        "services.title": "Serviciile noastre",
    },
    en: {
        "nav.home": "Home",
        "nav.shop": "Shop",
        "nav.packages": "Packages",
        "nav.services": "Services",
        "nav.portfolio": "Portfolio",
        "nav.blog": "Blog",
        "nav.contact": "Contact",
        "nav.login": "Sign in",
        "nav.account": "My account",
        "nav.cart": "Cart",
        "common.loading": "Loading...",
        "common.save": "Save",
        "common.cancel": "Cancel",
        "common.delete": "Delete",
        "common.search": "Search...",
        "cta.add_to_cart": "Add to cart",
        "cta.request_service": "Request this service",
        "product.out_of_stock": "Out of stock",
        "product.notify_me": "Notify me when back in stock",
        "product.specs": "Specifications",
        "product.description": "Description",
        "product.reviews": "Reviews",
        "product.share": "Share",
        "checkout.total": "Total",
        "services.title": "Our services",
    },
};

const I18nContext = React.createContext({ lang: "ro", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
    const [lang, setLangState] = React.useState(() => {
        try { return localStorage.getItem("st_lang") || (navigator.language || "").slice(0, 2) === "en" ? "en" : "ro"; }
        catch { return "ro"; }
    });

    const setLang = React.useCallback((l) => {
        setLangState(l);
        try { localStorage.setItem("st_lang", l); document.documentElement.lang = l; } catch {}
    }, []);

    const t = React.useCallback((key, fallback) => {
        return DICT[lang]?.[key] || DICT.ro[key] || fallback || key;
    }, [lang]);

    React.useEffect(() => { try { document.documentElement.lang = lang; } catch {} }, [lang]);

    return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => React.useContext(I18nContext);
